import styled from "@emotion/styled";
import { Box, Card, Grid } from "@mui/material";

// `bloqueado` fica fora do DOM: o styled repassa props desconhecidas para o
// Card, e o React reclamaria de um atributo booleano inválido no <div>.
export const PaperEstabelecimento = styled(Card, {
    shouldForwardProp: prop => prop !== "bloqueado"
})<{ bloqueado?: boolean }>`
    display: flex;
    border-radius: 32px;
    transition: box-shadow 0.3s, border-color 0.3s;
    background-color: ${props => props.bloqueado ? props.theme.palette.action.hover : "inherit"};
    cursor: ${props => props.bloqueado ? "not-allowed" : "pointer"};

    /* Sem realce no hover quando não há para onde ir. */
    &:hover {
        box-shadow: ${props => props.bloqueado ? "none" : "0 8px 24px rgba(0, 0, 0, 0.12)"};
        border-color: ${props => props.bloqueado ? "inherit" : props.theme.palette.primary.main};
    }
`

export const TituloPagina = styled(Grid)`
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;

    @media(max-width: 768px) {
        align-items: center;
        flex-direction: column;

        button {
            margin-top: 1rem;
        }
    }
`

export const LogoContainer = styled(Box)`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: ${props => props.theme.palette.divider};
    flex-shrink: 0;
`
